import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Button, Container, styled, Box } from "@mui/material";
import * as _ from "lodash";
import { AppDispatch, RootState } from "../../state/store"
import { createUserAsync, initialNewUserPayload, setCurrentForm, setCurrentPage, setOtpToken, setOtpVerificationStep, setPmsModal, storeUserPayload, toggleModal } from "../../state/auth/authSlice"
// import { fetchUserDetailsAsync } from "../../state/user/userSlice";
import {
  ERROR_MESSAGE,
  INSTRUCTIONS,
  pmsDropDownList
} from "../../utils/constantTypes";
import {
  validateConfirmPassword,
  validateEmail,
  validateMobile,
  validateName,
  validatePassword,
} from "../../utils/validation";
import { IMAGE_PATHS } from "../../utils/imagePaths";
import { encryptData, getSignupProcessFlags, isAdmin } from "../../utils/index";
import AuthFrame from "../../components/AuthFrame";
import AlertBox from "../../components/AlertBox";
import TextInput from "../../components/TextField";
import BasicSelect from "../../components/BasicSelect";
import StaticModal from "../../components/StaticModal";
import SmsVerification from "../../components/SmsVerification"
import PracticeForm from "../../components/PracticeForm"
// import SikkaWebView from "../../components/SikkaWebView"
import PhoneInputElements from "../../components/PhoneInput"
import ProgressLoader from '../../components/Loader/index';
import FieldIconContainer from "../../components/FieldIconContainer";
import { iconContainerStyle, iconStyle } from "./login";
import { ERRORS, SIGNUP_PROCESS_STEPS } from "../../constants/index";

export const RequiredField = styled('span')({
  color: 'red',
  fontWeight: 'bold'
})

interface Props {
  navigation: {
    navigate: () => void;
    goBack: () => void;
  };
  onPressContinue?: any;
  setIsLoading: Function;
  fromScreen: string;
}
export interface TextInputProps {
  id?: string;
  labelImageName?: string;
  label?: any;
  labelStyles?: object;
  value: string;
  onChangeText: (text: string) => void;
  onIconClick?: () => void;
  onFocus?: () => void;
  marginBottom?: number;
  width?: number;
  iconName?: string;
  iconColor?: string;
  inputContainerStyle?: object;
  validateErrormsg?: string;
  validateError?: boolean;
  editable?: boolean;
  keyboardType?: string;
  IconStyle?: object;
  dropDownInput?: boolean;
  multiline?: boolean;
  letterSpacing?: boolean;
  testID?: string;
  accessibilityLabel?: string;
  icon?: any;
  placeholder?: string;
  autoComplete?: string;
  dropdownListArr?: any[];
  type?: string;
  inputProps?: boolean;
  passwordVisible?: boolean;
  required?: boolean;
  instruction?: string | React.ReactNode;
  instructionStyle?: object;
  disabled?: boolean;
  style?: object;
  ref?: any;
  handleOnFocus?: () => void;
  currentForm?: string;
  rows?: number;
  readonly?: boolean;
  validateErrorMsg?: string;
}

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: `${theme.spacing(2)} 0px`,
  borderRadius: '60px',
  color: '#081B22',
  background: 'linear-gradient(97.57deg, #89E141 -27.78%, #29E6CE 112.55%)',
}));

const areEmailsEqual = (primary: string, secondary: string) => {
  if (!primary.trim() || !secondary.trim()) {
    return false;
  }
  return primary.trim().toLowerCase() === secondary.trim().toLowerCase();
};

const getDigitsOnly = (value: string = "") => value.replace(/\D/g, '');

const hasPhoneValue = (phone: string, countryDialCode: string) => {
  const digits = getDigitsOnly(phone);
  if (!digits.length) {
    return false;
  }
  const dialCodeDigits = getDigitsOnly(countryDialCode);
  return digits.length > dialCodeDigits.length;
};

const arePhoneNumbersEqual = (primary: string, secondary: string) => {
  const primaryDigits = getDigitsOnly(primary);
  const secondaryDigits = getDigitsOnly(secondary);
  if (!primaryDigits || !secondaryDigits) {
    return false;
  }
  return primaryDigits === secondaryDigits;
};

export const CustomStyledContainer = styled(Container)(() => (
  {
    height: "400px",
    overflowY: "auto",

    /* For WebKit (Chrome, Safari, Opera) */
    "&::-webkit-scrollbar": {
      width: "2px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#89E141",
      borderRadius: "2px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    }
  }
))
const MODAL_DATA = {
  VALID: {
    id: "valid-pms-modal",
    title: "Your practice management software is not completely supported so you will have to perform some steps manually.",
    subTitle: "Do you wish to continue?",
    icon: "candle",
    backBtn: true,
  },
  INVALID: {
    id: "invalid-pms-modal",
    title: "Sorry! At this practice management software is not supported. We will contact you once your practice management software is supported.",
    subTitle: "",
    icon: "danger",
    backBtn: false,
  }
}
const SignUp = (
) => {
  const { currentForm, currentPage, isPmsValid, showModal, loading, newUserPayload, otpToken } = useSelector((state: RootState) => state.auth);
  const { type, show, message } = useSelector((state: RootState) => state.utils);
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [mobileError, showMobileError] = useState<boolean | string>(false)
  const [secondaryMobileNo, setSecondaryMobileNo] = useState("");
  const [secondaryMobileNoError, setSecondaryMobileNoError] = useState("");
  const [secondaryMobileError, showSecondaryMobileError] = useState<boolean | string>(false);
  const [emailError, setEmailError] = useState("");
  const [secondaryEmail, setSecondaryEmail] = useState("");
  const [secondaryEmailError, setSecondaryEmailError] = useState("");
  const [countryCode, setCountryCode] = useState("+1");
  const [secondaryCountryCode, setSecondaryCountryCode] = useState("+1");
  const [email, setEmail] = useState("");
  const emailRef = useRef<HTMLInputElement>(null);
  const primaryMobileNoRef = useRef<HTMLInputElement>(null);
  const secondaryMobileNoRef = useRef<HTMLInputElement>(null);
  const role = "Dentist";
  const [password, setPassword] = useState("");
  const [pms, setPms] = useState("Eaglesoft");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confpasswordVisible, setConfpasswordVisible] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confPasswordError, setConfPasswordError] = useState("");
  const [pmsList, setPmsList] = useState(JSON.parse(JSON.stringify(pmsDropDownList)));
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    // Resume incomplete-signup practice step from login; don't reset to account form
    if (currentForm !== 'practice' && currentForm !== 'sms') {
      dispatch(setCurrentForm('signup'));
    }
    dispatch(setCurrentPage('signup'));
  }, []);

  const checkNoError = () => {
    let status = true;
    const hasSecondaryEmailValue = Boolean(secondaryEmail?.trim()?.length);
    const hasSecondaryMobileValue = hasPhoneValue(secondaryMobileNo, secondaryCountryCode);
    if (
      !firstName ||
      !mobileNo ||
      !hasSecondaryMobileValue ||
      !email ||
      !password ||
      !confirmPassword ||
      firstNameError ||
      mobileNoError ||
      secondaryMobileNoError ||
      emailError ||
      (hasSecondaryEmailValue && secondaryEmailError) ||
      passwordError ||
      confPasswordError
    ) {
      status = false;
    }
    return status;
  };

  const validateField = async () => {
    const hasSecondaryEmailValue = Boolean(secondaryEmail?.trim()?.length);
    const hasSecondaryMobileValue = hasPhoneValue(secondaryMobileNo, secondaryCountryCode);
    const hasDuplicateEmail = hasSecondaryEmailValue && areEmailsEqual(email, secondaryEmail);
    const hasDuplicatePhone =
      hasSecondaryMobileValue &&
      hasPhoneValue(mobileNo, countryCode) &&
      arePhoneNumbersEqual(mobileNo, secondaryMobileNo);

    if (!firstName) {
      setFirstNameError(ERROR_MESSAGE.firstNameRequiredMsg);
    }
    if (mobileNo.slice(countryCode.length + 1).length === 0) {
      showMobileError(true);
      setMobileNoError(ERROR_MESSAGE.phoneRequiredMsg);
    }
    if (secondaryMobileNo.slice(secondaryCountryCode.length + 1).length === 0) {
      showSecondaryMobileError(true);
      setSecondaryMobileNoError(ERROR_MESSAGE.secondaryPhoneRequiredMsg);
    }
    if (!email) {
      setEmailError(ERROR_MESSAGE.emailRequiredMsg);
    }
    if (hasDuplicateEmail) {
      setEmailError(ERROR_MESSAGE.DISTINCT_EMAILS_REQ);
      setSecondaryEmailError(ERROR_MESSAGE.DISTINCT_EMAILS_REQ);
    }
    if (!password) {
      setPasswordError(ERROR_MESSAGE.passwordRequiredMsg);
    }
    if (!confirmPassword) {
      setConfPasswordError(ERROR_MESSAGE.confPasswordRequiredMsg);
    }
    if (hasDuplicatePhone) {
      setMobileNoError(ERROR_MESSAGE.DISTINCT_PHONE_NO_REQ);
      setSecondaryMobileNoError(ERROR_MESSAGE.DISTINCT_PHONE_NO_REQ);
    }
    if (!hasDuplicateEmail && !hasDuplicatePhone && checkNoError()) {
      await createUser({ stepType: SIGNUP_PROCESS_STEPS.VERIFY_NEW_USER })
    }
  }

  const createUser = async ({ stepType, otp = "", otpToken = '' }: { stepType: string, otp?: string, otpToken?: string }) => {
    const flags = getSignupProcessFlags(stepType, otp, otpToken)
    const userPayload: any = {
      firstName,
      lastName,
      fullName: `${firstName.trim()} ${lastName.trim()}`,
      userName: `${firstName.trim()}_${lastName.trim()}`,
      email,
      ...(secondaryEmail?.trim()?.length
        ? { additionalEmails: [secondaryEmail] }
        : {}),
      phoneNumber: {
        countryCode: `+${countryCode}`,
        number: mobileNo.slice(countryCode.length + 1)
      },
      ...(hasPhoneValue(secondaryMobileNo, secondaryCountryCode)
        ? {
            additionalPhoneNumber: [
              `+${secondaryCountryCode}${secondaryMobileNo.slice(secondaryCountryCode.length + 1)}`
            ]
          }
        : {}),
      role,
      password,
      managementSoftware: pms,
      notificationSetting: { email: false, sms: false, push: true },
      isEmailOptVerified: false,
      stepType,
      ...flags
    };

    try {
      const userRes = await dispatch(createUserAsync(userPayload));
      const statusCode = _.get(userRes, 'payload.statusCode');
      const msg = _.get(userRes, 'payload.message');
      // User already exists
      if (statusCode === 400 && msg === ERRORS.EXISTING_EMAIL) {
        const handleErrMsg = () => {
          setEmailError(ERRORS.EXISTING_EMAIL);
        };
        scrollAndHighlightEmail(emailRef, handleErrMsg);
        return;
      }
      else if(statusCode === 400 && msg === ERRORS.INVALID_MOBILE_NUM){
        const handleErrMsg = () => {
          setMobileNoError(ERROR_MESSAGE.mobileFormatErrorMsg);
        };
        scrollAndHighlightEmail(primaryMobileNoRef, handleErrMsg);
        return;
      }
      else if(statusCode === 400 && msg === ERRORS.INVALID_SECONDARY_MOBILE_NUM){
        const handleErrMsg = () => {
          setSecondaryMobileNoError(ERROR_MESSAGE.mobileFormatErrorMsg);
        };
        scrollAndHighlightEmail(secondaryMobileNoRef, handleErrMsg);
        return;
      }
      if (
        statusCode !== 400 &&
        stepType === SIGNUP_PROCESS_STEPS.VERIFY_NEW_USER
      ) {
        await handleContinue();
      }
    }
    catch (err) {
      console.log(`Error on create user on ${stepType} step`, err)
    }

  }

  const scrollAndHighlightEmail = (fieldRef,handleErrMsg) => {
    if (fieldRef.current) {
      fieldRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      handleErrMsg();
    }
  };

  const textInputs: TextInputProps[] = [
    {
      label: 'First Name',
      labelStyles: { marginTop: 28, marginBottom: 8 },
      placeholder: 'First Name',
      testID: 'firstname-input',
      accessibilityLabel: 'firstname-input',
      value: firstName,
      onChangeText: (text: string) => {
        validate(text, 'firstname');
      },
      validateError: firstNameError ? true : false,
      validateErrormsg: firstNameError,
      icon: (
        <FieldIconContainer
          imgSrc={IMAGE_PATHS.PROFILE}
          imgStyle={iconStyle}
          containerStyle={iconContainerStyle}
        />
      ),
      type: 'text',
      required: true
    },
    {
      label: 'Last Name',
      labelStyles: { marginTop: 28, marginBottom: 8 },
      placeholder: 'Last Name',
      testID: 'lastname-input',
      accessibilityLabel: 'lastname-input',
      validateError: lastNameError ? true : false,
      validateErrormsg: lastNameError,
      value: lastName,
      onChangeText: (text: string) => {
        validate(text, 'lastname');
      },
      icon: (
        <FieldIconContainer
          imgSrc={IMAGE_PATHS.PROFILE}
          imgStyle={iconStyle}
          containerStyle={iconContainerStyle}
        />
      ),
      type: 'text'
    },
    {
      labelImageName: 'sms',
      label: 'Email',
      placeholder: 'Email',
      testID: 'email-input',
      value: email,
      validateError: emailError ? true : false,
      validateErrormsg: emailError,
      onChangeText: (text: string) => {
        validate(text, 'email');
      },
      icon: (
        <FieldIconContainer
          imgSrc={IMAGE_PATHS.EMAIL}
          imgStyle={iconStyle}
          containerStyle={iconContainerStyle}
        />
      ),
      type: 'email',
      required: true,
      ref: emailRef,
      instruction: INSTRUCTIONS.SECURITY_CODE
    },
    {
      labelImageName: 'sms',
      label: 'Secondary Email (Optional)',
      placeholder: 'Secondary Email',
      testID: 'secondary-email-input',
      value: secondaryEmail,
      validateError: secondaryEmailError ? true : false,
      validateErrormsg: secondaryEmailError,
      onChangeText: (text: string) => {
        validate(text, 'secondaryEmail');
      },
      icon: (
        <FieldIconContainer
          imgSrc={IMAGE_PATHS.EMAIL}
          imgStyle={iconStyle}
          containerStyle={iconContainerStyle}
        />
      ),
      type: 'email',
      required: false,
    },
    {
      labelImageName: 'lock',
      label: 'Password',
      labelStyles: { marginTop: 28, marginBottom: 8 },
      placeholder: 'Password',
      testID: 'password-input',
      accessibilityLabel: 'password-input',
      value: password,
      passwordVisible,
      iconName: passwordVisible ? 'eye-off' : 'eye-outline',
      validateErrormsg: passwordError,
      validateError: passwordError ? true : false,
      onChangeText: (text: string) => {
        validate(text, 'password');
      },
      onIconClick: () => {
        setPasswordVisible((prev) => !prev);
      },
      type: 'password',
      icon: (
        <FieldIconContainer
          imgSrc={IMAGE_PATHS.PASSWORD}
          imgStyle={iconStyle}
          containerStyle={iconContainerStyle}
        />
      ),
      inputProps: true,
      required: true
    },
    {
      labelImageName: 'lock',
      label: 'Confirm Password',
      labelStyles: { marginTop: 28, marginBottom: 8 },
      placeholder: 'Confirm Password',
      value: confirmPassword,
      testID: 'confirmpassword-input',
      accessibilityLabel: 'confirmpassword-input',
      validateError: confPasswordError ? true : false,
      validateErrormsg: confPasswordError,
      iconName: confpasswordVisible ? 'eye-off' : 'eye-outline',
      passwordVisible: confpasswordVisible,
      onIconClick: () => {
        setConfpasswordVisible((prev) => !prev);
      },
      onChangeText: (text: string) => {
        validate(text, 'confirmPassword');
      },
      type: 'password',
      icon: (
        <FieldIconContainer
          imgSrc={IMAGE_PATHS.PASSWORD}
          imgStyle={iconStyle}
          containerStyle={iconContainerStyle}
        />
      ),
      inputProps: true,
      required: true
    },
    {
      labelImageName: 'tickCircle',
      label: 'Select Your Practice Management Software',
      labelStyles: { marginTop: 28, marginBottom: 8 },
      placeholder: 'Select Your PMS',
      testID: 'pms-input',
      accessibilityLabel: 'pms-input',
      value: pms,
      onChangeText: setPms,
      editable: false,
      dropDownInput: true,
      iconName: 'chevron-down-outline',
      dropdownListArr: pmsList,
      type: 'text',
      icon: (
        <FieldIconContainer
          imgSrc={IMAGE_PATHS.CHECK}
          imgStyle={iconStyle}
          containerStyle={iconContainerStyle}
        />
      )
    }
  ];
  const validate = (text: string, type: string) => {
    switch (type) {
      case "firstname":
        setFirstName(text);
        let firstNameError = validateName(text);
        setFirstNameError(firstNameError);
        break;
      case "lastname":
        setLastName(text);
        let lastNameError = validateName(text);
        setLastNameError(lastNameError);
        if (text) {
          let lastNameError = validateName(text);
          setLastNameError(lastNameError);
        } else {
          setLastNameError("");
        }
        break;
      case "email":
        {
          setEmail(text);
          const primaryEmailError = validateEmail(text);
          const hasSecondaryEmail = Boolean(secondaryEmail?.trim()?.length);
          const secondaryEmailValidationError = hasSecondaryEmail ? validateEmail(secondaryEmail) : "";
          const shouldShowDistinctEmailError =
            !primaryEmailError &&
            !secondaryEmailValidationError &&
            hasSecondaryEmail &&
            areEmailsEqual(text, secondaryEmail);

          if (shouldShowDistinctEmailError) {
            setEmailError(ERROR_MESSAGE.DISTINCT_EMAILS_REQ);
            setSecondaryEmailError(ERROR_MESSAGE.DISTINCT_EMAILS_REQ);
          } else {
            setEmailError(primaryEmailError);
            if (hasSecondaryEmail && secondaryEmailError === ERROR_MESSAGE.DISTINCT_EMAILS_REQ) {
              setSecondaryEmailError(secondaryEmailValidationError);
            }
            if (!hasSecondaryEmail) {
              setSecondaryEmailError("");
            }
          }
          break;
        }
      case "secondaryEmail":
        {
          setSecondaryEmail(text);
          const hasSecondaryEmail = Boolean(text?.trim()?.length);
          if (hasSecondaryEmail) {
            const optionalSecondaryEmailError = validateEmail(text);
            const primaryEmailError = validateEmail(email);
            const shouldShowDistinctEmailError =
              !optionalSecondaryEmailError &&
              !primaryEmailError &&
              areEmailsEqual(email, text);

            if (shouldShowDistinctEmailError) {
              setSecondaryEmailError(ERROR_MESSAGE.DISTINCT_EMAILS_REQ);
              setEmailError(ERROR_MESSAGE.DISTINCT_EMAILS_REQ);
            } else {
              setSecondaryEmailError(optionalSecondaryEmailError);
              if (emailError === ERROR_MESSAGE.DISTINCT_EMAILS_REQ) {
                setEmailError(primaryEmailError);
              }
            }
          } else {
            setSecondaryEmailError("");
            if (emailError === ERROR_MESSAGE.DISTINCT_EMAILS_REQ) {
              setEmailError(validateEmail(email));
            }
          }
          break;
        }
      case "mobile":
        {
          setMobileNo(text);
          const primaryMobileError = validateMobile(text);
          const primaryHasValue = hasPhoneValue(text, countryCode);
          const hasSecondaryMobile = hasPhoneValue(secondaryMobileNo, secondaryCountryCode);
          const secondaryMobileValidationError = hasSecondaryMobile ? validateMobile(secondaryMobileNo) : "";
          const shouldShowDistinctPhoneError =
            primaryHasValue &&
            !primaryMobileError &&
            hasSecondaryMobile &&
            !secondaryMobileValidationError &&
            arePhoneNumbersEqual(text, secondaryMobileNo);

          if (shouldShowDistinctPhoneError) {
            setMobileNoError(ERROR_MESSAGE.DISTINCT_PHONE_NO_REQ);
            setSecondaryMobileNoError(ERROR_MESSAGE.DISTINCT_PHONE_NO_REQ);
          } else {
            setMobileNoError(primaryMobileError);
            if (hasSecondaryMobile && secondaryMobileNoError === ERROR_MESSAGE.DISTINCT_PHONE_NO_REQ) {
              setSecondaryMobileNoError(secondaryMobileValidationError);
            }
            if (!hasSecondaryMobile) {
              setSecondaryMobileNoError("");
            }
          }
          break;
        }
      case "secondaryMobile":
        {
          setSecondaryMobileNo(text);
          const hasSecondaryMobile = hasPhoneValue(text, secondaryCountryCode);
          if (hasSecondaryMobile) {
            const optionalMobileError = validateMobile(text);
            const primaryMobileError = validateMobile(mobileNo);
            const primaryHasValue = hasPhoneValue(mobileNo, countryCode);
            const shouldShowDistinctPhoneError =
              primaryHasValue &&
              !optionalMobileError &&
              !primaryMobileError &&
              arePhoneNumbersEqual(mobileNo, text);

            if (shouldShowDistinctPhoneError) {
              setSecondaryMobileNoError(ERROR_MESSAGE.DISTINCT_PHONE_NO_REQ);
              setMobileNoError(ERROR_MESSAGE.DISTINCT_PHONE_NO_REQ);
            } else {
              setSecondaryMobileNoError(optionalMobileError);
              if (mobileNoError === ERROR_MESSAGE.DISTINCT_PHONE_NO_REQ) {
                setMobileNoError(primaryMobileError);
              }
            }
          } else {
            setSecondaryMobileNoError("");
            if (mobileNoError === ERROR_MESSAGE.DISTINCT_PHONE_NO_REQ) {
              setMobileNoError(validateMobile(mobileNo));
            }
          }
          break;
        }
      case "password":
        setPassword(text);
        let passwordError = validatePassword(text);
        setPasswordError(passwordError);
        if (confirmPassword) {
          let confPasswordErr = validateConfirmPassword(confirmPassword, text);
          setConfPasswordError(confPasswordErr);
        }
        break;
      case "confirmPassword":
        setConfirmPassword(text);
        let confPasswordErr = validateConfirmPassword(text, password);
        setConfPasswordError(confPasswordErr);
        break;
    }
  };

  const handleContinue = async () => {
    dispatch(toggleModal(false));
    await createUser({ stepType: SIGNUP_PROCESS_STEPS.SEND_EMAIL_OTP })
  };

  const handleCloseModal = async () => {
    dispatch(toggleModal(false))
  };

  const handleOtpVerify = async ({ stepType, otp, otpToken }) => {
    await createUser({ stepType, otp, otpToken })
  }

  const handleOtpResend = async () => {
    await createUser({ stepType: newUserPayload.isEmailOptVerified ? SIGNUP_PROCESS_STEPS.RESEND_MOBILE_OTP : SIGNUP_PROCESS_STEPS.RESEND_EMAIL_OTP, otpToken })
  }
  // const modalData = (({ isPmsValid, showModal, handleCloseModal, handleContinue }) => {
  //   return {
  //     ...(isPmsValid ? { ...MODAL_DATA.VALID } : { ...MODAL_DATA.INVALID }), showModal, handleCloseModal, handleContinue
  //   }
  // })({ isPmsValid, showModal, handleCloseModal, handleContinue });

  // const handleOnWebViewClose = async () => {
  //   const _loginFrom = encryptData(process.env.REACT_APP_LOGIN_FROM);
  //   try {
  //     const loginRes = await dispatch(loginAsync({ username: email, password, loginFrom: _loginFrom }))
  //     const accessToken = _.get(loginRes, 'payload.accessToken');
  //     if (accessToken) {
  //       dispatch(setLoader(true))
  //       setTimeout(async () => {
  //         const userDetailsRes: any = await dispatch(fetchUserDetailsAsync({ accessToken }))
  //         const officeId = _.get(userDetailsRes, 'payload.officeId');
  //         const role = _.get(userDetailsRes, 'payload.role');
  //         dispatch(setLoader(false))
  //         dispatch(setCurrentForm(''));
  //         if (officeId && isAdmin(role)) {
  //           navigate('/')
  //         }
  //         else if (officeId) {
  //           navigate('/subscriptions/plan')
  //         }
  //         else {
  //           navigate('/accounts/profile')
  //         }
  //       }, 3000);
  //     }
  //   }
  //   catch (err) {
  //     console.log("Error on login from sikka web view")
  //   }
  // }

  const handleBackBtnClick = () => {
    if (currentForm === 'signup' && currentPage === 'signup') {
      setCurrentForm('login');
      setCurrentPage('login');
      navigate('/login');
    }
    else {
      dispatch(setCurrentForm('signup'));
    }
    dispatch(setOtpVerificationStep({ isEmailOptVerified: false }));
    dispatch(setOtpToken({ otpToken: null }));
    dispatch(setPmsModal(false));
    dispatch(storeUserPayload(initialNewUserPayload));
  };

  return (
    <>
      <AlertBox type={type} showAlert={show} message={message} />
      <ProgressLoader loading={loading} />
      <AuthFrame
        currentForm={currentForm}
        title={
          currentForm === 'signup' || !currentForm
            ? 'Create a DentScribe Account'
            : ''
        }
        handleBackBtnClick={handleBackBtnClick}
      >
        {currentForm === 'signup' ? (
          <>
            <CustomStyledContainer>
              {currentForm === 'signup' ? (
                <p>Stay on this page until the sign-up is fully processed.</p>
              ) : null}
              <Box pb={2}>
                Begin setting up your account now. Should you decide to
                subscribe to DentScribe, you’ll have the option to add your
                payment details in the following step.
              </Box>
              <Box>
                <Box>
                  {textInputs.slice(0, 2).map((textInput) => (
                    <TextInput key={textInput.label} {...textInput} />
                  ))}
                </Box>
                <Box pb={2}>
                  <PhoneInputElements
                    showMobileError={showMobileError}
                    setCountryCode={setCountryCode}
                    mobileNo={mobileNo}
                    mobileNoError={mobileNoError}
                    emptyError={mobileError}
                    validate={validate}
                    validationType="mobile"
                    ref={primaryMobileNoRef}
                  />
                  <Box pb={2}>
                    We will send a security code to this number for verification
                  </Box>
                  <PhoneInputElements
                    showMobileError={showSecondaryMobileError}
                    setCountryCode={setSecondaryCountryCode}
                    mobileNo={secondaryMobileNo}
                    mobileNoError={secondaryMobileNoError}
                    emptyError={secondaryMobileError}
                    validate={validate}
                    validationType="secondaryMobile"
                    label="Secondary Phone Number"
                    required={true}
                    ref={secondaryMobileNoRef}
                  />
                </Box>
                <Box>
                  {textInputs.slice(2, 4).map((textInput) => (
                    <TextInput
                      key={textInput.label}
                      {...textInput}
                      currentForm={currentForm}
                      {...(textInput?.ref ? { ref: textInput?.ref } : {})}
                    />
                  ))}
                </Box>
                <Box>
                  {textInputs.slice(4, 6).map((textInput) => (
                    <TextInput key={textInput.label} {...textInput} />
                  ))}
                </Box>
                <Box>
                  <BasicSelect
                    value={pms}
                    key={textInputs[textInputs.length - 1].label}
                    {...textInputs[textInputs.length - 1]}
                  />
                </Box>
              </Box>
              <Box>
                <StyledButton
                  variant="contained"
                  fullWidth
                  onClick={validateField}
                >
                  Continue
                </StyledButton>
              </Box>
            </CustomStyledContainer>
          </>
        ) : (
          <>
            {currentForm === 'sms' ? (
              <SmsVerification
                handleOtpVerify={handleOtpVerify}
                handleOtpResend={handleOtpResend}
                mobileNo={mobileNo}
                email={email}
              />
            ) : currentForm === 'practice' ? (
              <PracticeForm />
            ) : // : currentForm === "sikka" ?
            //   <SikkaWebView path="/login" onClose={handleOnWebViewClose} />
            null}
          </>
        )}
      </AuthFrame>
      {/* <StaticModal {...modalData} /> */}
    </>
  );
};
export default SignUp;
